function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-43.081 -334.159)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(43.081 334.159)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M270.793,244a26.793,26.793,0,1,0,26.793,26.793A26.822,26.822,0,0,0,270.793,244Z",
  transform: "translate(-244 -244)",
  fill: "#0078d7"
}), /*#__PURE__*/React.createElement("text", {
  transform: "translate(12.07 45.41)",
  fill: "#fff",
  fontSize: 53,
  fontFamily: "Axiforma-Regular, Axiforma"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "+"))));

function SvgCirclePlusIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.586,
    height: 57.41,
    viewBox: "0 0 53.586 57.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlusIcon);
export default __webpack_public_path__ + "static/media/circle-plus-icon.eb0bb4e2.svg";
export { ForwardRef as ReactComponent };